import React, { useCallback, useContext, useEffect, useState } from "react";
import classes from "./SearchBox.module.css";
import { toast } from "react-toastify";
import {
  Box,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AuthContext from "../../authContext";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  addSearchData,
  addSelectedBook,
  deleteSelectedBook,
  editSearchData,
  resetSearchData,
} from "../../../redux/productSlice";
import { useNavigate } from "react-router-dom";
import img from "../../../../assets/bookPlaceHolder.png";
import { stripHtmlTags, truncateText } from "../../TextUtils";
import { debounce } from "../../Utilities/debounce"; // Ensure this import is correct

function SearchBox() {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );
  const [selectedOption, setSelectedOption] = useState("Book"); // Default selected option
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const authCtx = useContext(AuthContext);
  const [catsearchQuery, setCatSearchQuery] = useState("");
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchData = useSelector((state) => state.products.searchData);

  const handleSearchInputChange = (e) => {
    setCatSearchQuery(e.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length >= 2) {
        // Ensure minimum query length
        setLoading(true);
        const fetchArticles = async () => {
          try {
            let url = `${process.env.REACT_APP_TESTING_API}/articles?ecom_type=${process.env.REACT_APP_ECOM_TYPE}&`;

            url += `smart_search=${searchQuery}`;
            const response = await axios.get(url);
            setArticles(response.data.data);
          } catch (error) {
            // toast.error(`${language === 'eng' ? "Failed to fetch articles." : "Échec de la recherche d'articles."}`);
          } finally {
            setLoading(false);
          }
        };
        fetchArticles();
      }
    }, 500); // 1 second delay

    return () => clearTimeout(timer); // Cleanup on component unmount or when searchQuery changes
  }, [searchQuery, selectedOption, language]);

  // useEffect(() => {
  //   debouncedHandleSearch();
  // }, [searchQuery, selectedOption, debouncedHandleSearch]);

  const handleSearchSubmit = () => {
    localStorage.removeItem("category");
    localStorage.removeItem("collection");
    localStorage.removeItem("date");
    dispatch(resetSearchData());

    // Initialize the search object
    let search = {};

    // Dynamically set the search key based on the selected option
    if (selectedOption === "Book") {
      search = { title: searchQuery };
    } else if (selectedOption === "Author") {
      search = { author: searchQuery };
    } else if (
      selectedOption === "Illustrator" ||
      selectedOption === "Translator"
    ) {
      search = { traducteur: searchQuery };
    } else if (selectedOption === "Editor") {
      search = { editor: searchQuery };
    } else if (selectedOption === "Collection") {
      search = { collection: searchQuery };
    } else if (selectedOption === "EAN") {
      search = { ean: searchQuery };
    } else if (selectedOption === "Resume") {
      search = { resume: searchQuery };
    }

    // Dispatch the search data, combining with existing search data if necessary
    dispatch(editSearchData({ ...search }));

    // If the current path is /products, reload the page, otherwise navigate
    if (window.location.pathname === "/books") {
      window.location.reload(); // Reload if already on /products
    } else {
      navigate("/books"); // Navigate to /products if not already there
    }

    // Clear the search query
    setSearchQuery("");
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          borderRadius: "20px",
          background: "#fff",
          border: "1px solid #f3f3f3",
        }}
        className={classes.custom_select}
      >
        {/* <FormControl
          sx={{
            color: "#fff",
          }}
          variant="standard"
          style={{
            width: "20%",
            height: "100%",
            borderRadius: "20px",
            background: "var(--primary-color)",
            border: "1px solid var(--primary-color)",
            padding: "0.6% 1% 0.4% 1%",
            marginLeft: "0",
            textAlign: "center",
            textDecoration: "none",
            outline: "none",
            color: "#fff !important",
          }}
        >
          <Select
            disableUnderline
            displayEmpty
            className={classes.focus}
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            sx={{
              color: "#fff",
              "& svg": {
                color: "#fff", // Change the color of the arrow
              },
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search..."
                onChange={handleSearchInputChange}
                value={searchQuery}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <i
                        className="fas fa-search"
                        style={{ color: "#fff" }}
                      ></i>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          >
            <MenuItem value="Book">{language === 'eng' ? "Products" : "Produits"}</MenuItem>
            <MenuItem value="Collection">{language === 'eng' ? "Collections" : "Collections"}</MenuItem>
            <MenuItem value="Author">{language === 'eng' ? "Authors" : "Auteurs"}</MenuItem>
            <MenuItem value="Editor">{language === 'eng' ? "Editors" : "Editeurs"}</MenuItem>
            <MenuItem value="Illustrator">{language === 'eng' ? "Illustrators" : "Illustrateurs"}</MenuItem>
            <MenuItem value="Translator">{language === 'eng' ? "Translators" : "Traducteurs"}</MenuItem>
            <MenuItem value="EAN">{language === 'eng' ? "EAN" : "EAN"}</MenuItem>
            <MenuItem value="Resume">{language === 'eng' ? "Resume" : "Resume"}</MenuItem>
          </Select>
        </FormControl> */}
        <input
          type="text"
          placeholder={
            selectedOption === "Book"
              ? language === "eng"
                ? "Find your books here..."
                : "Trouvez vos livres ici..."
              : language === "eng"
              ? `Find your ${selectedOption.toLowerCase()} books here...`
              : `Trouvez vos livres ${selectedOption.toLowerCase()} ici...`
          }
          value={searchQuery}
          className={classes.input}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsDropdownOpen(true)}
          onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
          style={{
            width: "100%",
            borderRadius: "20px",
            padding: "1%",
            paddingLeft: "2%",
            background: "#fff",
          }}
        />
        {/* <button
          className={classes.btn}
          onClick={handleSearchSubmit}
        >
          {language === 'eng' ? "SEARCH" : "RECHERCHER"}
        </button> */}
        {articles?.length > 0 && searchQuery.length > 1 && isDropdownOpen && (
          <div className={classes.dropdown1}>
            {loading ? (
              <div style={{ padding: "2em", textAlign: "center" }}>
                <h1 style={{ margin: "auto" }}>Loading...</h1>
              </div>
            ) : (
              <>
                {articles.map((article, index) => (
                  <div
                    key={index}
                    className={classes.dropdown_card}
                    onClick={() => {
                      authCtx.setbookDetails(article);
                      dispatch(deleteSelectedBook(article.id));
                      dispatch(addSelectedBook(article));
                      setSearchQuery("");
                      navigate(`/bookdetails/${article.id}`);
                      // console.log(article.id);
                    }}
                  >
                    <div
                      className={classes.dropdown_card_img}
                      style={{ position: "relative" }}
                    >
                      {article?._qte_a_terme_calcule < 1 && (
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className={classes.out_of_stock}
                        >
                          <p>
                            {language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}
                          </p>
                        </div>
                      )}
                      {article.articleimage[0] ? (
                        <img
                          src={`${article.articleimage[0]?.link}`}
                          alt=""
                          width="100%"
                          height="100%"
                          className={classes.img}
                        />
                      ) : (
                        <img
                          src={img}
                          className={classes.img}
                          alt=""
                          width="100%"
                          height="100%"
                        />
                      )}
                    </div>
                    <div className={classes.dropdown_card_content}>
                      <h3>{article.designation}</h3>
                      {/* <p style={{fontSize:'calc(0.6rem + 0.2vw)'}}>{article.dc_auteur}</p> */}
                      {/* <p style={{ margin: "0", fontSize: "calc(0.6rem + 0.2vw)" }}>{truncateText(stripHtmlTags(article.descriptif), 70)}</p> */}
                      {article._qte_a_terme_calcule < 1 && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "calc(0.6rem + 0.2vw)",
                            fontWeight: 600,
                          }}
                        >
                          {language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}
                        </p>
                      )}
                      <p style={{ fontSize: "calc(0.6rem + 0.3vw)" }}>
                        {currency === "eur"
                          ? `${
                              article.discount > 0
                                ? (
                                    article._prix_public_ttc -
                                    article._prix_public_ttc *
                                      (article.discount / 100)
                                  ).toFixed(2)
                                : Number(article._prix_public_ttc).toFixed(2)
                            } €`
                          : `${
                              article.discount > 0
                                ? (
                                    (article._prix_public_ttc -
                                      article._prix_public_ttc *
                                        (article.discount / 100)) *
                                    authCtx.currencyRate
                                  ).toFixed(2)
                                : (
                                    article._prix_public_ttc *
                                    authCtx.currencyRate
                                  ).toFixed(2)
                            } $`}{" "}
                        {article.discount > 0 && (
                          <span
                            style={{
                              opacity: "0.8",
                              textDecoration: "line-through",
                            }}
                          >
                            {currency === "eur"
                              ? `${Number(article._prix_public_ttc).toFixed(
                                  2
                                )} € `
                              : `${(
                                  article._prix_public_ttc *
                                  authCtx.currencyRate
                                ).toFixed(2)} $ `}
                          </span>
                        )}
                      </p>
                      {(() => {
                        const fieldsToCheck = [
                          {
                            key: "designation",
                            value: article.designation,
                            name_en: "Title: ",
                            name_fr: "Titre: ",
                          },
                          {
                            key: "descriptif",
                            value: article.descriptif,
                            name_en: "Resume: ",
                            name_fr: "Résumé: ",
                          },
                          {
                            key: "_code_barre",
                            value: article._code_barre,
                            name_en: "EAN: ",
                            name_fr: "EAN: ",
                          },
                          {
                            key: "dc_collection",
                            value: article.dc_collection,
                            name_en: "Collection: ",
                            name_fr: "Collection: ",
                          },
                          {
                            key: "dc_auteur",
                            value: article.dc_auteur,
                            name_en: "Author: ",
                            name_fr: "Auteur: ",
                          },
                          {
                            key: "editor",
                            value: article?.dc_editor,
                            name_en: "Editor: ",
                            name_fr: "Editeur: ",
                          },
                          {
                            key: "dc_traducteur",
                            value: article.dc_traducteur,
                            name_en: "Translator: ",
                            name_fr: "Traducteur: ",
                          },
                          {
                            key: "dc_illustrateur",
                            value: article.dc_illustrateur,
                            name_en: "Illustrator: ",
                            name_fr: "Illustrateur: ",
                          },
                          {
                            key: "category",
                            value: article.categories?._nom,
                            name_en: "Category: ",
                            name_fr: "Catégorie: ",
                          },
                        ];

                        // Find the first field that matches the search query case-insensitively
                        const matchedField = fieldsToCheck.find(({ value }) =>
                          value
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        );

                        return matchedField ? (
                          matchedField.key === "descriptif" ? (
                            <p style={{ color: "red", display: "flex" }}>
                              <span>
                                {language === "eng"
                                  ? matchedField.name_en
                                  : matchedField.name_fr}
                              </span>
                              <p style={{ color: "red" }} className={classes.p}>
                                {" "}
                                {truncateText(
                                  stripHtmlTags(matchedField.value),
                                  5000
                                )}
                              </p>
                            </p>
                          ) : (
                            <p style={{ color: "red" }}>
                              <span>
                                {language === "eng"
                                  ? matchedField.name_en
                                  : matchedField.name_fr}
                              </span>
                              {matchedField.value}
                            </p>
                          )
                        ) : null;
                      })()}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          width: "100%",
          borderRadius: "20px",
          background: "#fff",
          border: "1px solid #f3f3f3",
        }}
        className={classes.custom_select_mob}
      >
        <SearchIcon
          style={{ color: "#ACACAC", margin: "auto 0.2em", width: "1em" }}
        />
        <input
          type="text"
          placeholder={
            selectedOption === "Book"
              ? language === "eng"
                ? "Find your books here..."
                : "Trouvez vos livres ici..."
              : language === "eng"
              ? `Find your ${selectedOption.toLowerCase()} books here...`
              : `Trouvez vos livres ${selectedOption.toLowerCase()} ici...`
          }
          value={searchQuery}
          className={classes.input}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsDropdownOpen(true)}
          onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
          style={{
            borderRadius: "20px",
            padding: "1%",
            background: "#fff",
          }}
        />
        {articles?.length > 0 && searchQuery.length > 1 && isDropdownOpen && (
          <div className={classes.dropdown2}>
            {loading ? (
              <div style={{ padding: "2em", textAlign: "center" }}>
                <h1 style={{ margin: "auto" }}>Loading...</h1>
              </div>
            ) : (
              <>
                {articles.map((article, index) => (
                  <div
                    key={index}
                    className={classes.dropdown_card}
                    onClick={() => {
                      authCtx.setbookDetails(article);
                      dispatch(deleteSelectedBook(article.id));
                      dispatch(addSelectedBook(article));
                      setSearchQuery("");
                      navigate(`/bookdetails/${article.id}`);
                      // console.log(article.id);
                    }}
                  >
                    <div
                      className={classes.dropdown_card_img}
                      style={{ position: "relative" }}
                    >
                      {article?._qte_a_terme_calcule < 1 && (
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className={classes.out_of_stock}
                        >
                          <p>
                            {language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}
                          </p>
                        </div>
                      )}
                      {article.articleimage[0] ? (
                        <img
                          src={`${article.articleimage[0]?.link}`}
                          alt=""
                          width="100%"
                          height="100%"
                          className={classes.img}
                        />
                      ) : (
                        <img
                          src={img}
                          className={classes.img}
                          alt=""
                          width="100%"
                          height="100%"
                        />
                      )}
                    </div>
                    <div className={classes.dropdown_card_content}>
                      <h3>{article.designation}</h3>
                      {/* <p style={{fontSize:'calc(0.6rem + 0.2vw)'}}>{article.dc_auteur}</p> */}
                      {/* <p style={{ margin: "0", fontSize: "calc(0.6rem + 0.2vw)" }}>{truncateText(stripHtmlTags(article.descriptif), 70)}</p> */}
                      {article._qte_a_terme_calcule < 1 && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "calc(0.6rem + 0.2vw)",
                            fontWeight: 600,
                          }}
                        >
                          {language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}
                        </p>
                      )}
                      <p style={{ fontSize: "calc(0.7rem + 0.3vw)" }}>
                        {currency === "eur"
                          ? `${
                              article.discount > 0
                                ? (
                                    article._prix_public_ttc -
                                    article._prix_public_ttc *
                                      (article.discount / 100)
                                  ).toFixed(2)
                                : Number(article._prix_public_ttc).toFixed(2)
                            } €`
                          : `${
                              article.discount > 0
                                ? (
                                    (article._prix_public_ttc -
                                      article._prix_public_ttc *
                                        (article.discount / 100)) *
                                    authCtx.currencyRate
                                  ).toFixed(2)
                                : (
                                    article._prix_public_ttc *
                                    authCtx.currencyRate
                                  ).toFixed(2)
                            } $`}{" "}
                        {article.discount > 0 && (
                          <span
                            style={{
                              opacity: "0.8",
                              textDecoration: "line-through",
                            }}
                          >
                            {currency === "eur"
                              ? `${Number(article._prix_public_ttc).toFixed(
                                  2
                                )} € `
                              : `${(
                                  article._prix_public_ttc *
                                  authCtx.currencyRate
                                ).toFixed(2)} $ `}
                          </span>
                        )}
                      </p>
                      {(() => {
                        const fieldsToCheck = [
                          {
                            key: "designation",
                            value: article.designation,
                            name_en: "Title: ",
                            name_fr: "Titre: ",
                          },
                          {
                            key: "descriptif",
                            value: article.descriptif,
                            name_en: "Description: ",
                            name_fr: "Descriptif: ",
                          },
                          {
                            key: "_code_barre",
                            value: article._code_barre,
                            name_en: "EAN: ",
                            name_fr: "EAN: ",
                          },
                          {
                            key: "dc_collection",
                            value: article.dc_collection,
                            name_en: "Collection: ",
                            name_fr: "Collection: ",
                          },
                          {
                            key: "dc_auteur",
                            value: article.dc_auteur,
                            name_en: "Author: ",
                            name_fr: "Auteur: ",
                          },
                          {
                            key: "editor",
                            value: article?.dc_editor,
                            name_en: "Editor: ",
                            name_fr: "Editeur: ",
                          },
                          {
                            key: "dc_traducteur",
                            value: article.dc_traducteur,
                            name_en: "Translator: ",
                            name_fr: "Traducteur: ",
                          },
                          {
                            key: "dc_illustrateur",
                            value: article.dc_illustrateur,
                            name_en: "Illustrator: ",
                            name_fr: "Illustrateur: ",
                          },
                        ];

                        // Find the first field that matches the search query case-insensitively
                        const matchedField = fieldsToCheck.find(({ value }) =>
                          value
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        );

                        return matchedField ? (
                          matchedField.key === "descriptif" ? (
                            <p
                              style={{ color: "red", display: "flex" }}
                              className={classes.font}
                            >
                              <span>
                                {language === "eng"
                                  ? matchedField.name_en
                                  : matchedField.name_fr}
                              </span>
                              <p style={{ color: "red" }} className={classes.p}>
                                {" "}
                                {truncateText(
                                  stripHtmlTags(matchedField.value),
                                  5000
                                )}
                              </p>
                            </p>
                          ) : (
                            <p
                              style={{ color: "red" }}
                              className={classes.font}
                            >
                              <span>
                                {language === "eng"
                                  ? matchedField.name_en
                                  : matchedField.name_fr}
                              </span>
                              {matchedField.value}
                            </p>
                          )
                        ) : null;
                      })()}{" "}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SearchBox;
